import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobxAngularModule } from 'mobx-angular';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { MenuListItemComponent } from './menu-list-item/menu-list-item.component';
import { RecipeComponent } from './recipe/recipe.component';
import { InfoListItemComponent } from './info-list-item/info-list-item.component';
import { GuideComponent } from './guide/guide.component';
import { ShoppingListComponent } from './shopping-list/shopping-list.component';
import { CalendarDayComponent } from './calendar-day/calendar-day';
import { IonicHeaderParallaxModule } from '../ionic-header-parallax/lib/ionic-header-parallax.module';
@NgModule({
  declarations: [
    MenuListItemComponent,
    InfoListItemComponent,
    RecipeComponent,
    GuideComponent,
    ShoppingListComponent,
    CalendarDayComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    IonicHeaderParallaxModule,
    MobxAngularModule,
    TranslateModule,
    FormsModule
  ],
  exports: [
    MenuListItemComponent,
    InfoListItemComponent,
    RecipeComponent,
    GuideComponent,
    ShoppingListComponent,
    CalendarDayComponent
  ],
  providers: [ ]
})
export class SharedModule { }
